(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7505],{

/***/ 79477:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/[[...page]]",
      function () {
        return __webpack_require__(5860);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72433);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47956);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7154);
/* harmony import */ var _hooks_usePageAuth__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85614);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27514);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88751);
/* harmony import */ var _components_AemGrid__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(30390);
/* harmony import */ var _components_core_Head_NextHead__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(46760);
/* harmony import */ var _components_Default_BreadCrumb__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(42053);
/* harmony import */ var _components_ContactUs_v1_ContactUs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(2788);
/* harmony import */ var _components_KeySpecifier_v1_KeySpecifier__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(48440);
/* harmony import */ var _components_AssociateMembership_v1_AssociateMembership__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(21137);
/* harmony import */ var _components_Literature_v1_Literature__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(11419);
/* harmony import */ var _components_TechnicalSpecs_v1_TechnicalSpecs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(25778);
/* harmony import */ var _components_ProductDetail_v3_ProductAccordion__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(22644);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(73750);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(10884);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageLayout__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(82706);
/* harmony import */ var _components_KnowledgeArticle_v1_KnowledgeArticle__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(99056);
/* harmony import */ var _components_KnowledgeArticle_v1_KnowledgeArticleFiller__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(79491);
/* harmony import */ var _components_BrowseAllStores_v1_BrowseAllStores__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(53087);
/* harmony import */ var _components_FriendsAndFamily_v1_FriendsAndFamily__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(5619);
/* harmony import */ var _components_InstallDesignServices_v1_InstallDesignServices__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(5642);
/* harmony import */ var _components_FindStore_v1_FindStore__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(50481);
/* harmony import */ var _components_ProductList_v2_ProductList__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(30906);
/* harmony import */ var _components_ProductList_v2_PLPLoader__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(26655);
/* harmony import */ var _components_Shared_UpsellInstallServices__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(95843);
/* harmony import */ var _components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(55266);
/* harmony import */ var _components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(_components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var _components_ProductList_v2_ProductTile_index_module_scss__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(20711);
/* harmony import */ var _components_ProductList_v2_ProductTile_index_module_scss__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(_components_ProductList_v2_ProductTile_index_module_scss__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(87292);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(64925);
/* harmony import */ var _store_features_productListSlice__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(42286);
/* harmony import */ var _components_LeadGeneration__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(43769);








































const StoreDataTags = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>__webpack_require__.e(/* import() */ 3149).then(__webpack_require__.bind(__webpack_require__, 63149)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(63149)
            ]
    }
});
/**
 * renders home page
 * @return {JSX.Element}
 */ function Page(param) {
    let { tmpData: data , headertmp: header , footertmp: footer , ip , globalScript , footerScript , analyticsData , gbhDataLayerCustom , fullUrl , urlNames , data404 , datalayerPageName , plpData ={} , storeData ={}  } = param;
    var ref;
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
    const { brandLogoImg , menu: { isOpen , mainCategoryActive , isRegionOpen , isAuthNavOpen  }  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .selectGenericState */ .Px);
    const { cartUrl  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_35__/* .selectCartState */ .xw);
    const [pageRedirect, setPageRedirect] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [isScrollMarginRequired, setIsScrollMarginRequired] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    var ref1;
    const [urlRefValue, setUrlValue] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("#".concat((ref1 = router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("#")[1]) !== null && ref1 !== void 0 ? ref1 : ""));
    const { pageUrl ="" , redirectTarget: { page: { path =""  } = {}  } = {}  } = data;
    const { scroll: defaultScrollValue  } = _constants__WEBPACK_IMPORTED_MODULE_8__.DEFAULT_SCROLL;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common");
    (0,_hooks_usePageAuth__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    const cartCount = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_34__/* .getCartCount */ .c0)();
    const ariaLabel = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_34__/* .getAriaLabel */ .Xw)(t, cartCount);
    const toggleMenu = ()=>{
        if (isOpen) {
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .closeMenu */ .Wj)());
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setAuthNav */ .AT)(false));
        } else {
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .openMenu */ .qn)());
        }
    };
    const redirect = ()=>{
        router.push("".concat(cartUrl));
    };
    const eventHandler = {
        store: {
            brandLogoImg: brandLogoImg,
            isOpen,
            mainCategoryActive,
            isRegionOpen,
            isAuthNavOpen,
            cartCount,
            ariaLabel,
            cartUrl,
            plp: {
                ...plpData,
                status: "succeeded"
            }
        },
        callbacks: {
            setBrandLogoImg: (path)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setBrandLogoImg */ .XY)(path));
            },
            closeMenu: ()=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .closeMenu */ .Wj)());
            },
            setMainCategory: (payload)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setActiveMainCategory */ .X7)(payload));
            },
            toggleMenu: ()=>{
                toggleMenu();
            },
            setRegionNav: (active)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setRegionNav */ .qX)(active));
            },
            setAuthNav: (active)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setAuthNav */ .AT)(active));
            },
            setGlobalScripts: (item)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setGlobalScripts */ .n8)(item));
            },
            setGlobalStyles: (item)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setGlobalStyles */ .cw)(item));
            },
            onClick: ()=>{
                redirect();
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (plpData) {
            dispatch((0,_store_features_productListSlice__WEBPACK_IMPORTED_MODULE_36__/* .setPlpData */ .gS)({
                ...plpData,
                status: "succeeded",
                initialLoad: true
            }));
        }
        if (gbhDataLayerCustom.pageType === "plp") {
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setDatalayerPageName */ .dN)(datalayerPageName));
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setGbhDataLayerCustom */ .ks)(gbhDataLayerCustom));
            return ()=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setDatalayerPageName */ .dN)(""));
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setGbhDataLayerCustom */ .ks)(""));
            };
        }
    }, [
        datalayerPageName,
        gbhDataLayerCustom,
        plpData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (pageUrl) {
            var ref, ref1, ref2, ref3;
            const containsString = _constants__WEBPACK_IMPORTED_MODULE_8__.DISABLE_SROLL_PATH.some((str)=>pageUrl.includes(str));
            var ref4;
            const installServiceHash = (ref4 = (router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_8__.INSTALLATION_SERVICES_ASPATH)) && (router === null || router === void 0 ? void 0 : (ref1 = router.asPath) === null || ref1 === void 0 ? void 0 : ref1.includes("#"))) !== null && ref4 !== void 0 ? ref4 : false;
            var ref5;
            const buyingGuideHash = (ref5 = (router === null || router === void 0 ? void 0 : (ref2 = router.asPath) === null || ref2 === void 0 ? void 0 : ref2.includes(_constants__WEBPACK_IMPORTED_MODULE_8__.BUYING_GUIDE_ASPATH)) && (router === null || router === void 0 ? void 0 : (ref3 = router.asPath) === null || ref3 === void 0 ? void 0 : ref3.includes("#"))) !== null && ref5 !== void 0 ? ref5 : false;
            if (containsString) {
                window.scrollTo({
                    top: 1,
                    behavior: "smooth"
                });
            }
            if (installServiceHash || buyingGuideHash) {
                var ref6;
                const element = (ref6 = document.querySelector("".concat(urlRefValue))) !== null && ref6 !== void 0 ? ref6 : {};
                const offsetTop = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__/* .getOffsetTop */ .oJS)(element) - defaultScrollValue;
                window.scrollTo({
                    top: offsetTop,
                    behavior: "smooth",
                    left: 0
                });
            }
        }
    }, [
        pageUrl,
        urlRefValue
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (ip) sessionStorage.setItem("true-ip", ip);
    }, [
        ip
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref, ref1;
        dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setGbhDataLayerCustom */ .ks)(gbhDataLayerCustom));
        if (router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.includes(_constants__WEBPACK_IMPORTED_MODULE_8__.PRIVACY_ASPATH)) {
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setPageIsIntercative */ .Ys)(true));
        }
        if (router === null || router === void 0 ? void 0 : (ref1 = router.asPath) === null || ref1 === void 0 ? void 0 : ref1.includes(_constants__WEBPACK_IMPORTED_MODULE_8__.INSTALLATION_SERVICES_ASPATH)) {
            setIsScrollMarginRequired(true);
        }
        const handleHashChange = ()=>{
            const hash = window.location.hash;
            setUrlValue(hash);
        };
        window.addEventListener("hashchange", handleHashChange);
        return ()=>{
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setGbhDataLayerCustom */ .ks)(""));
            window.removeEventListener("hashchange", handleHashChange);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__/* .getDataLayerObj */ .C2G)(analyticsData);
    }, [
        analyticsData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (path) {
            setPageRedirect((0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__/* .removeAndCleanLink */ .xEh)(path));
        }
    }, [
        path
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!isSsr && pageRedirect) {
            router.replace(pageRedirect);
        }
    }, [
        isSsr,
        pageRedirect
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__/* .getScriptsAndStyles */ .csL)(data);
    }, [
        data
    ]);
    const getStoreApplicationJsonLDData = ()=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
        const applicationJsonLdData = {};
        const address = {};
        const geo = {};
        const weekdays = {};
        const saturday = {};
        const sunday = {};
        applicationJsonLdData["@context"] = _constants__WEBPACK_IMPORTED_MODULE_8__.STORE_APP_LD_JSON.context;
        applicationJsonLdData["@type"] = _constants__WEBPACK_IMPORTED_MODULE_8__.STORE_APP_LD_JSON.type;
        address["@type"] = _constants__WEBPACK_IMPORTED_MODULE_8__.STORE_APP_LD_JSON.addressType;
        address.streetAddress = storeData === null || storeData === void 0 ? void 0 : (ref = storeData.schema) === null || ref === void 0 ? void 0 : ref.street;
        address.addressLocality = storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.schema) === null || ref1 === void 0 ? void 0 : ref1.locality;
        address.addressRegion = storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.schema) === null || ref2 === void 0 ? void 0 : ref2.region;
        address.postalCode = storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.schema) === null || ref3 === void 0 ? void 0 : ref3.zipCode;
        address.addressCountry = storeData === null || storeData === void 0 ? void 0 : (ref4 = storeData.schema) === null || ref4 === void 0 ? void 0 : ref4.country;
        weekdays["@type"] = _constants__WEBPACK_IMPORTED_MODULE_8__.STORE_APP_LD_JSON.openingHourType;
        weekdays.dayOfWeek = [
            _constants__WEBPACK_IMPORTED_MODULE_8__.STORE_APP_LD_JSON.openingDays.monday,
            _constants__WEBPACK_IMPORTED_MODULE_8__.STORE_APP_LD_JSON.openingDays.tuesday,
            _constants__WEBPACK_IMPORTED_MODULE_8__.STORE_APP_LD_JSON.openingDays.wednesday,
            _constants__WEBPACK_IMPORTED_MODULE_8__.STORE_APP_LD_JSON.openingDays.thursday,
            _constants__WEBPACK_IMPORTED_MODULE_8__.STORE_APP_LD_JSON.openingDays.friday
        ];
        weekdays.opens = storeData === null || storeData === void 0 ? void 0 : (ref5 = storeData.schema) === null || ref5 === void 0 ? void 0 : ref5.weekdayOpenHour;
        weekdays.closes = storeData === null || storeData === void 0 ? void 0 : (ref6 = storeData.schema) === null || ref6 === void 0 ? void 0 : ref6.weekdayCloseHour;
        saturday["@type"] = _constants__WEBPACK_IMPORTED_MODULE_8__.STORE_APP_LD_JSON.openingHourType;
        saturday.dayOfWeek = [
            _constants__WEBPACK_IMPORTED_MODULE_8__.STORE_APP_LD_JSON.openingDays.saturday
        ];
        saturday.opens = storeData === null || storeData === void 0 ? void 0 : (ref7 = storeData.schema) === null || ref7 === void 0 ? void 0 : ref7.saturdayOpenHour;
        saturday.closes = storeData === null || storeData === void 0 ? void 0 : (ref8 = storeData.schema) === null || ref8 === void 0 ? void 0 : ref8.saturdayCloseHour;
        sunday["@type"] = _constants__WEBPACK_IMPORTED_MODULE_8__.STORE_APP_LD_JSON.openingHourType;
        sunday.dayOfWeek = [
            _constants__WEBPACK_IMPORTED_MODULE_8__.STORE_APP_LD_JSON.openingDays.sunday
        ];
        sunday.opens = storeData === null || storeData === void 0 ? void 0 : (ref9 = storeData.schema) === null || ref9 === void 0 ? void 0 : ref9.sundayOpenHour;
        sunday.closes = storeData === null || storeData === void 0 ? void 0 : (ref10 = storeData.schema) === null || ref10 === void 0 ? void 0 : ref10.sundayCloseHour;
        geo["@type"] = _constants__WEBPACK_IMPORTED_MODULE_8__.STORE_APP_LD_JSON.geoType;
        geo.latitude = storeData === null || storeData === void 0 ? void 0 : (ref11 = storeData.schema) === null || ref11 === void 0 ? void 0 : ref11.latitude;
        geo.longitude = storeData === null || storeData === void 0 ? void 0 : (ref12 = storeData.schema) === null || ref12 === void 0 ? void 0 : ref12.longitude;
        applicationJsonLdData.name = storeData === null || storeData === void 0 ? void 0 : (ref13 = storeData.schema) === null || ref13 === void 0 ? void 0 : ref13.name;
        applicationJsonLdData.image = storeData === null || storeData === void 0 ? void 0 : (ref14 = storeData.schema) === null || ref14 === void 0 ? void 0 : ref14.image;
        applicationJsonLdData.description = storeData === null || storeData === void 0 ? void 0 : (ref15 = storeData.schema) === null || ref15 === void 0 ? void 0 : ref15.description;
        applicationJsonLdData.hasMap = storeData === null || storeData === void 0 ? void 0 : (ref16 = storeData.schema) === null || ref16 === void 0 ? void 0 : ref16.hasMap;
        applicationJsonLdData.url = storeData === null || storeData === void 0 ? void 0 : (ref17 = storeData.schema) === null || ref17 === void 0 ? void 0 : ref17.url;
        applicationJsonLdData.telephone = storeData === null || storeData === void 0 ? void 0 : (ref18 = storeData.schema) === null || ref18 === void 0 ? void 0 : ref18.telephone;
        applicationJsonLdData.priceRange = storeData === null || storeData === void 0 ? void 0 : (ref19 = storeData.schema) === null || ref19 === void 0 ? void 0 : ref19.priceRange;
        applicationJsonLdData.address = {
            ...address
        };
        applicationJsonLdData.geo = {
            ...geo
        };
        applicationJsonLdData.openingHoursSpecification = [
            {
                ...weekdays
            },
            {
                ...saturday
            },
            {
                ...sunday
            }
        ];
        return JSON.stringify(applicationJsonLdData);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            data ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Head_NextHead__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                ...data,
                fullUrl: fullUrl
            }) : null,
            (data === null || data === void 0 ? void 0 : data.templateName) == "store-detail-page" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_7___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    children: getStoreApplicationJsonLDData()
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageLayout__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                header: header ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                    header: header,
                    title: data.title,
                    globalScripting: globalScript
                }) : null,
                footer: footer ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                    footer: footer,
                    footerScripting: footerScript
                }) : null,
                children: data ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AemGrid__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    eventHandler: eventHandler,
                    isScrollMarginRequired: isScrollMarginRequired,
                    data: data,
                    count: 0,
                    breadCrumb: (data, fullData)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Default_BreadCrumb__WEBPACK_IMPORTED_MODULE_15__["default"], {
                            data: data,
                            fullData: fullData
                        }),
                    productAccordion: (data, fullData)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductDetail_v3_ProductAccordion__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                            data: data,
                            fullData: fullData
                        }),
                    contactUsFiller: ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_KnowledgeArticle_v1_KnowledgeArticleFiller__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {}),
                    contactUs: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ContactUs_v1_ContactUs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            data: data
                        }),
                    leadGeneration: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LeadGeneration__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
                            data: data
                        }),
                    keySpecifier: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_KeySpecifier_v1_KeySpecifier__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            data: data
                        }),
                    associateMembership: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AssociateMembership_v1_AssociateMembership__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            data: data
                        }),
                    friendsAndFamily: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FriendsAndFamily_v1_FriendsAndFamily__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                            data: data
                        }),
                    literature: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Literature_v1_Literature__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            data: data
                        }),
                    technicalSpecifications: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TechnicalSpecs_v1_TechnicalSpecs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                            data: data
                        }),
                    knowledgeArticle: (data, urlNames)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_KnowledgeArticle_v1_KnowledgeArticle__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                            data: data,
                            urlNames: urlNames,
                            data404: data404
                        }),
                    knowledgeArticleFiller: ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_KnowledgeArticle_v1_KnowledgeArticleFiller__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {}),
                    urlNames: urlNames,
                    browseAllStores: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BrowseAllStores_v1_BrowseAllStores__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                            data: data
                        }),
                    installDesignServices: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_InstallDesignServices_v1_InstallDesignServices__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                            data: data
                        }),
                    findStore: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FindStore_v1_FindStore__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                            data: data
                        }),
                    productList: (data, eventHandler)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductList_v2_ProductList__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                            data: data,
                            eventHandler: eventHandler
                        }),
                    productListFiller: ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "".concat((_components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_38___default().productListWrapper), " ").concat((_components_ProductList_v2_ProductTile_index_module_scss__WEBPACK_IMPORTED_MODULE_39___default().productTileWrapper)),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductList_v2_PLPLoader__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {})
                        }),
                    upSellContainer: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_UpsellInstallServices__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z, {
                            authData: data
                        })
                }) : null
            }),
            !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default()(storeData) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StoreDataTags, {
                authData: storeData
            }) : null
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,6351,6342,4432,7333,4904,361,9851,4303,6331,5921,4204,4382,3785,919,5843,5531,1304,1934,9450,7866,3236,3707,9786,873,906,9774,2888,179], function() { return __webpack_exec__(79477); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);